
      /* <AUTO-GENERATED-SCRIPTS> */
  // Event emitted when an accordion item is opened.
        document.querySelector('#ifx-accordion-example ifx-accordion')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

        // Event emitted when an accordion item is closed.
        document.querySelector('#ifx-accordion-example ifx-accordion')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

            // Event emitted when the main item area is clicked
        document.querySelector('#ifx-action-list-example ifx-action-list')?.addEventListener('ifxActionListItemClick', (event) => {
          console.log('ifxActionListItemClick:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted when close button clicked.
        document.querySelector('#ifx-alert-example ifx-alert')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

            // Custom event that is triggered when the checkbox is clicked.
        document.querySelector('#ifx-checkbox-example ifx-checkbox')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted when an checkbox has an error.
        document.querySelector('#ifx-checkbox-example ifx-checkbox')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

            // Method to set the error state of all checkboxes in the group.
        document.querySelector('#ifx-checkbox-group-example ifx-checkbox-group')?.addEventListener('setGroupError', (event) => {
          console.log('setGroupError:', event);
          // Add your custom handler logic here
        });

            // A custom event emitted when the selection in a *<ifx-chip>* is updated.
        document.querySelector('#ifx-chip-example ifx-chip')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted when a different content-switcher-item gets selected. Contains the value of the previous and the new selected item.
        document.querySelector('#ifx-content-switcher-example ifx-content-switcher')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // A custom event emitted when a date in the calendar is being selected.
        document.querySelector('#ifx-date-picker-example ifx-date-picker')?.addEventListener('ifxDate', (event) => {
          console.log('ifxDate:', event);
          // Add your custom handler logic here
        });

            // Custom event that is emitted when the dropdown opens.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted when dropdown closes.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted by ifx-dropdown-menu when an item is selected.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxDropdownMenuItem', (event) => {
          console.log('ifxDropdownMenuItem:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted by ifx-sidebar-item when a navigation item becomes active on selection.
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarNavigationItem', (event) => {
          console.log('ifxSidebarNavigationItem:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted by ifx-sidebar-item when an action item is selected.
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarActionItem', (event) => {
          console.log('ifxSidebarActionItem:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted by ifx-sidebar-item when a menu is expanded or closed.
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarMenu', (event) => {
          console.log('ifxSidebarMenu:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted when the sidebar collapse state changes.
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarCollapseChange', (event) => {
          console.log('ifxSidebarCollapseChange:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted when page is changed.
        document.querySelector('#ifx-pagination-example ifx-pagination')?.addEventListener('ifxPageChange', (event) => {
          console.log('ifxPageChange:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted when the items per page is changed.
        document.querySelector('#ifx-pagination-example ifx-pagination')?.addEventListener('ifxItemsPerPageChange', (event) => {
          console.log('ifxItemsPerPageChange:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted when radio button checked and unchecked.
        document.querySelector('#ifx-radio-button-example ifx-radio-button')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted when radio button is in error state.
        document.querySelector('#ifx-radio-button-example ifx-radio-button')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

            // Method to set the error state of all checkboxes in the group.
        document.querySelector('#ifx-radio-button-group-example ifx-radio-button-group')?.addEventListener('setGroupError', (event) => {
          console.log('setGroupError:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted on input.
        document.querySelector('#ifx-search-bar-example ifx-search-bar')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Custom event emitted when the state of *isOpen* changes.
        document.querySelector('#ifx-search-bar-example ifx-search-bar')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

            // A custom event triggered whenever there is input in the search field.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Event triggered when the component requests suggestions for a query.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxSuggestionRequested', (event) => {
          console.log('ifxSuggestionRequested:', event);
          // Add your custom handler logic here
        });

        // Event triggered when a suggestion is selected from the dropdown.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxSuggestionSelected', (event) => {
          console.log('ifxSuggestionSelected:', event);
          // Add your custom handler logic here
        });

        // Event triggered when the search field receives focus.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxFocus', (event) => {
          console.log('ifxFocus:', event);
          // Add your custom handler logic here
        });

        // Event triggered when the search field loses focus.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxBlur', (event) => {
          console.log('ifxBlur:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted when item is selected.
        document.querySelector('#ifx-select-example ifx-select')?.addEventListener('ifxSelect', (event) => {
          console.log('ifxSelect:', event);
          // Add your custom handler logic here
        });

        // A custom event *ifxInput* is emitted immediately after the value of *Search* changes.
        document.querySelector('#ifx-select-example ifx-select')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

            // A custom event emitted when active step changes.
        document.querySelector('#ifx-stepper-example ifx-stepper')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // A custom event emitted when active step changes.
        document.querySelector('#ifx-stepper-example ifx-stepper')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted when the checked state changes.
        document.querySelector('#ifx-switch-example ifx-switch')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // A custom event triggered on checkbox selection
        document.querySelector('#ifx-table-example ifx-table')?.addEventListener('ifxSelectionChange', (event) => {
          console.log('ifxSelectionChange:', event);
          // Add your custom handler logic here
        });

        // A custom event emitted on column sort change
        document.querySelector('#ifx-table-example ifx-table')?.addEventListener('ifxSortChange', (event) => {
          console.log('ifxSortChange:', event);
          // Add your custom handler logic here
        });

            // Custom event that is emitted when the active tab changes.
        document.querySelector('#ifx-tabs-example ifx-tabs')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // Custom event emitted on input change.
        document.querySelector('#ifx-text-field-example ifx-text-field')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });
      /* </AUTO-GENERATED-SCRIPTS> */
      
      // Manual Examples - Modal
      const modal = document.getElementById('modal');
      const openButton = document.getElementById('open-modal');
      
      openButton?.addEventListener('click', () => {
        if (modal) {
          modal.opened = true;
        }
      });
      
      modal?.addEventListener('ifxOpen', (event) => {
        console.log('ifxOpen:', event.detail);
      });
      
      modal?.addEventListener('ifxClose', (event) => {
        console.log('ifxClose:', event.detail);
      });
    